import { fetchWithHeaders, responseData } from '../shared/utils'

export async function fetchCategories() {
  return fetchWithHeaders('/categories', {
    method: 'GET',
  })
    .then(responseData)
    .then(data => data.categories)
}

export async function fetchBaseCategories() {
  return fetchWithHeaders('/categories/base', {
    method: 'GET',
  })
    .then(responseData)
    .then(data => data.categories)
}

export async function fetchLocaleTags() {
  return fetchWithHeaders('/categories/locale-tags', {
    method: 'GET',
  })
    .then(responseData)
    .then(data => {
      return data.tags
    })
}
